"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DefaultFilterError = react_intl_1.injectIntl(function (_a) {
    var intl = _a.intl;
    var text = intl.formatMessage({ id: "gs.filter.error" });
    return react_1.default.createElement("div", { className: "gd-message error s-button-error" }, text);
});
exports.default = DefaultFilterError;
//# sourceMappingURL=AttributeFilterButtonDefaultError.js.map